import { OrderBy } from '.';
import { StatType } from './types';

const parsedData = window.location.pathname.split('/');

// Add basename only in production
export const DOMAIN = (process.env.NODE_ENV !== 'development') ?
  parsedData[1] :
  '';

export const ORIGIN = window.location.origin;

export const ON_DEV = process.env.REACT_APP_LOCALHOST && process.env.REACT_APP_POSEIDON ?
  window.location.origin.includes(process.env.REACT_APP_LOCALHOST) || window.location.origin.includes(process.env.REACT_APP_POSEIDON) :
  false;

export const HEADER_INC_API = process.env.REACT_APP_HEADERINCAPI;

export const ASC: OrderBy = 'ASC';
export const DESC: OrderBy = 'DESC';
export const NONE: OrderBy = 'NONE';

export enum PDOutputType {
  OUTPUT_CHART,
  OUTPUT_TABLE_ASOBJECT,
  OUTPUT_TABLE_ASJSON
}

export const TOTAL = 'TOTAL';
export const MEAN: StatType = 'MN';
export const PERCENT: StatType = 'RP';

export const isStatType = (str: string): str is StatType => {
  return (
    str === 'MN' ||
    str === 'RP'
  );
};

export const ERROR_RESPONSE = 'ErrorResponse';

export const SUBJECT_PROP = 'subject';
export const GRADE_PROP = 'grade';
export const GRADE_LIST_PROP = 'gradeList';


